// src/api/canteenApi.js
import apiClient from './axios';

const canteenApi = {
  // === MENU WITH SEARCH ===
  getMenus: async (search = '') => {
    const params = search ? `?search=${encodeURIComponent(search)}` : '';
    const res = await apiClient.get(`/menus/${params}`);
    return res.data; // Returns array directly when search is used
  },


  bulkCreateMenus: async (menus) => {
    const form = new FormData();
    const valid = menus.filter(m => m.name && m.price);

    valid.forEach((menu, i) => {
      form.append(`items[${i}][name]`, menu.name);
      form.append(`items[${i}][description]`, menu.description || '');
      form.append(`items[${i}][price]`, menu.price);
      form.append(`items[${i}][in_stock]`, menu.in_stock);

      if (menu.profile_img instanceof File) {
        form.append(`items[${i}][profile_img]`, menu.profile_img);
      }
    });

    const res = await apiClient.post('/menus/bulk-create/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  updateMenu: async (id, data) => {
    const form = new FormData();
    form.append(`name`, data.name);
    form.append(`description`, data.description ?? '');
    form.append(`price`, data.price);
    form.append(`in_stock`, data.in_stock);

    if (data.profile_img instanceof File) {
      form.append(`profile_img`, data.profile_img);
    } else if (data.profile_img === '') {
      form.append(`profile_img`, '');
    }

    const res = await apiClient.patch(`/menus/${id}/`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  deleteMenu: async (id) => {
    await apiClient.delete(`/menus/${id}/`);
  },

  getIngredients: async (menuId) => {
    const res = await apiClient.get(`/ingredients/?menu=${menuId}`);
    return res.data;
  },

  bulkCreateIngredients: async (ingredients) => {
    const res = await apiClient.post('/ingredients/bulk-create/', ingredients);
    return res.data;
  },

  updateIngredient: async (id, data) => {
    const res = await apiClient.patch(`/ingredients/${id}/`, data);
    return res.data;
  },

  deleteIngredient: async (id) => {
    await apiClient.delete(`/ingredients/${id}/`);
  },

  toggleStock: async (menuId) => {
  const res = await apiClient.post(`/menus/${menuId}/toggle-stock/`);
  return res.data; // expects the updated menu object
},
};

export default canteenApi;